export default "__VITE_ASSET__05cb64b4__"